export const Layout = ({ children }) => (
  <div
    style={{
      minHeight: "calc(100vh - 56px)",
    }}
  >
    {children}
  </div>
);
